export type NotificationType = 'success' | 'info' | 'error';
export const SYSTEM_NOTIFICATION_TYPES: NotificationType[] = ['success', 'error'];
